import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ComponentThreeViewCompare } from 'shared/device.z3k.tree-view-compare/ui';
import { useEffect } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { useComparisonConfig } from 'shared/hooks/device/z3k.compare';
export const CompareHistoryConfig = (props) => {
    const { newConfig, history_configs } = props;
    const [resultCompare, , compare] = useComparisonConfig(history_configs);
    useEffect(() => {
        compare(newConfig.config_parsed);
    }, []);
    return (_jsx(_Fragment, { children: resultCompare ? (_jsxs(Box, { display: "flex", children: [_jsx(ComponentThreeViewCompare, { title: "\u041D\u043E\u0432\u044B\u0435", resultCompare: resultCompare, keyResult: "new" }), _jsx(Divider, { orientation: "vertical", flexItem: true }), _jsx(ComponentThreeViewCompare, { title: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435", resultCompare: resultCompare, keyResult: "old" })] })) : (_jsx(Typography, { children: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u043D\u0435\u0442" })) }));
};
